import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

export function button4_click_1(event) {
    if ($w('#firstName').value === 'nimosasdtu') {
			wixLocation.to('https://www.zoomescape.co.il/good');
			}
	else if ($w('#firstName').value === 'Nimosasdtu') {
			wixLocation.to('https://www.zoomescape.co.il/good');
			}	
	else if ($w('#firstName').value === 'NIMOSASDTU') {
			wixLocation.to('https://www.zoomescape.co.il/good');
			}
	
	else {
		wixWindow.openLightbox("no");
	}/*
	    if ($w('#firstName').value === 'tinudassom') {
			wixLocation.to('https://www.questair.co.il/mossad-unit-flag');
			}
	else if ($w('#firstName').value === 'Tinudassom') {
			wixLocation.to('https://www.questair.co.il/mossad-unit-flag');
			}	
	else if ($w('#firstName').value === 'TINUDASSOM') {
			wixLocation.to('https://www.questair.co.il/mossad-unit-flag');
			}
	
	else {
		wixWindow.openLightbox("try");
	} */
	//Add your code for this event here: 
}